/**
 * Wallet shared functionality
 */
//vuex;
import { mapState, mapActions } from 'pinia'
import { useContractStore } from '@/store/modules/contract';
import { useUserStore } from '@/store/modules/user';
import { defineComponent } from 'vue';
import { useModalsStore } from '@/store/modules/modals';
import type { TSignMessage }from '@/helpers/types'


export default defineComponent({
	data() {
		return {
			waitOnMetamaskInterval: null as null | NodeJS.Timeout | number,
			waitOnWalletInterval: null as null | NodeJS.Timeout | number,
		};
	},
	computed: {
		...mapState(useContractStore, {
			morpherwallet: (state) => state.morpherwallet as any,
			wrongWallet: (state) => state.wrongWallet,
			wrongNetwork: (state) => state.wrongNetwork,
			eth_address: (state) => state.eth_address,
			walletClient: (state) => state.walletClient as any,

		}),
		...mapState(useUserStore, {
			user: state => state.data,
		}),

			

		
	},

	methods: {

		...mapActions(useContractStore, {
			startWallet: 'startWallet',
			checkWalletLoggedIn: 'checkWalletLoggedIn',
			morpherwalletLogout: 'morpherwalletLogout',
		}),
		...mapActions(useModalsStore, {
			toggleNetworkMetamaskModal: 'toggleNetworkMetamaskModal',
		}),

		// And in that case executes callback function which is passed in parameters and stops.
		async waitOnWalletCallback(callbackSuccess: any, callbackFail: any) {
			this.waitOnMetamaskInterval = setInterval(async () => {
				if (this.wrongWallet || this.wrongNetwork ) {
					
					if (this.user?.wallet_type === 'morpherwallet') {
						await this.morpherwalletLogout();
					}
					if (this.waitOnMetamaskInterval) {
						clearInterval(this.waitOnMetamaskInterval);
						this.waitOnMetamaskInterval = null;
					}
					this.$buefy.dialog.alert({
						title: this.$t('INCORRECT_ACCOUNT_HEAD'),
						message: this.$t('INCORRECT_ACCOUNT_TRADE'),
						confirmText: this.$t('OK')
					});

					callbackFail();
				}
				let loggedin = true;
				if (this.user?.wallet_type === 'morpherwallet') {
					const isLoggedIn = await this.morpherwallet.isLoggedIn();
					loggedin = isLoggedIn.isLoggedIn;
				}

				if (loggedin && this.wrongNetwork === false) {
					if (this.waitOnMetamaskInterval) {
						clearInterval(this.waitOnMetamaskInterval);
						this.waitOnMetamaskInterval = null;
					}
					callbackSuccess();
				}
			}, 1000);
		},
	
		async signTypedData(message: TSignMessage) {

			if (!this.walletClient) {
				throw new Error("No wallet client for signing");
				
			}
			const signature = await this.walletClient.signTypedData(message);

			return signature

		},

		// Resend the registration email if the users registration token has expired.
		async checkWalletReady(checkNetwork: boolean = true) {
			return new Promise((resolve, reject) => {
				if (this.user?.wallet_type === 'metamask' && this.wrongWallet) {

					this.$buefy.dialog.alert({
						title: this.$t('INCORRECT_ACCOUNT_HEAD'),
						message:
							this.$t('INCORRECT_ACCOUNT_METAMASK'),
						confirmText: this.$t('OK')
					});
					resolve(false)
					return
				}

				if (this.user?.wallet_type === 'metamask' && this.wrongNetwork && checkNetwork) {
					this.toggleNetworkMetamaskModal(true);
					resolve(false)
					return
				}

				if (this.user?.wallet_type === 'metamask' && (this.eth_address === '' || (this.wrongNetwork !== false && checkNetwork))) {
					this.startWallet({ load: true, order: false });
					if (this.waitOnWalletInterval) {
						clearTimeout(this.waitOnWalletInterval);
						this.waitOnWalletInterval = null;
					}

					this.waitOnWalletCallback(() => {
							resolve(true)
						}, () => {
							resolve(false)
						});
					return
					
				}

				this.checkWalletLoggedIn().then(() => {
					if (this.wrongWallet) {
						if (this.user?.wallet_type === 'morpherwallet') {
							this.morpherwalletLogout();
						}
						this.$buefy.dialog.alert({
							title: this.$t('INCORRECT_ACCOUNT_HEAD'),
							message: this.$t('INCORRECT_ACCOUNT_TRADE'),
							confirmText: this.$t('OK')
						});
						resolve(false)
						return
					}



					if (this.user?.wallet_type === 'morpherwallet') {
						this.morpherwallet.isLoggedIn().then((isLoggedIn: any) => {
							if (!isLoggedIn.isLoggedIn) {
								// start the wallet - order: true will ensure that the login is opened
								this.startWallet({ load: true, order: true });
								if (this.waitOnWalletInterval) {
									clearTimeout(this.waitOnWalletInterval);
									this.waitOnWalletInterval = null;
								}
								

								this.waitOnWalletCallback(() => {
									resolve(true)
								}, () => {
									resolve(false)
								});
								return
							} else {
								resolve(true)
								return
							}
						}).catch(()=> {
							this.$buefy.dialog.alert({
								title: this.$t('WALLET_CONNECT_ERROR_HEAD'),
								message: this.$t('WALLET_CONNECT_ERROR_TEXT'),
								confirmText: this.$t('OK')
							});
							resolve(false)
							return
						})
						return
					
					} else {
						resolve(true)
						return
					}
					
				}).catch(() => {
					this.$buefy.dialog.alert({
						title: this.$t('WALLET_CONNECT_ERROR_HEAD'),
						message: this.$t('WALLET_CONNECT_ERROR_TEXT'),
						confirmText: this.$t('OK')
					});
					resolve(false)
				});

				

				
			})


			
		
		},
		
	}
});
